import { useState, useEffect } from 'react';
import { API_GET_MENUS, API_GET_TEAMS_MENUS } from '../../../../api/configurationScreenServices';

/**
 * Custom hook to fetch menus and teams menus data
 * @returns {{ menuById: Object, menus: Object, loading: boolean }}
 */
export function useMenusData() {
  const [menuData, setMenuData] = useState({
    menuById: {},
    menus: null,
    loading: true
  });

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const [menusRes, teamsMenuRes] = await Promise.all([
          API_GET_MENUS(),
          API_GET_TEAMS_MENUS()
        ]);

        const menuItems = menusRes?.data || [];
        const menuById = Object.fromEntries(menuItems.map((menu) => [menu.menuId, menu]));

        setMenuData({
          menuById,
          menus: teamsMenuRes?.data || {},
          loading: false
        });
      } catch (error) {
        setMenuData({ menuById: {}, menus: {}, loading: false });
      }
    };

    fetchMenuData();
  }, []);

  return menuData;
}
